var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "free-icon-font-info-3916714",
    clipPath: "url(#clip0_25510_48827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.01306 16.2891C10.5953 16.2863 12.1412 15.8144 13.4552 14.933C14.7693 14.0517 15.7925 12.8004 16.3954 11.3375C16.9983 9.87467 17.1539 8.26586 16.8425 6.71456C16.5311 5.16326 15.7666 3.73914 14.6458 2.62229C13.525 1.50544 12.0982 0.746033 10.5458 0.440088C8.99345 0.134143 7.3852 0.295405 5.92446 0.903482C4.46372 1.51156 3.2161 2.53914 2.33937 3.85628C1.46264 5.17342 0.996178 6.72097 0.998968 8.30321C1.005 10.4242 1.85218 12.4562 3.35461 13.9534C4.85705 15.4505 6.89203 16.2905 9.01306 16.2891ZM8.99073 3.62245C9.18851 3.6221 9.38195 3.68041 9.54659 3.79C9.71124 3.89959 9.83969 4.05554 9.9157 4.23814C9.9917 4.42073 10.0119 4.62176 9.97362 4.81581C9.93538 5.00986 9.84045 5.18821 9.70084 5.32831C9.56124 5.46841 9.38322 5.56396 9.18931 5.60289C8.9954 5.64182 8.7943 5.62237 8.61144 5.547C8.42858 5.47164 8.27217 5.34374 8.162 5.17948C8.05183 5.01523 7.99284 4.82199 7.99249 4.62421C7.99203 4.359 8.09693 4.10446 8.28414 3.91659C8.47134 3.72872 8.72551 3.62292 8.99073 3.62245ZM8.32994 6.95695L8.99661 6.95578C9.35023 6.95516 9.68961 7.09503 9.9401 7.34464C10.1906 7.59425 10.3317 7.93314 10.3323 8.28676L10.3393 12.2868C10.3397 12.4636 10.2697 12.6333 10.1449 12.7585C10.0201 12.8837 9.85066 12.9543 9.67385 12.9546C9.49704 12.9549 9.32735 12.885 9.2021 12.7602C9.07686 12.6354 9.00632 12.4659 9.00601 12.2891L8.99896 8.28911L8.33229 8.29029C8.15548 8.2906 7.98579 8.22066 7.86054 8.09585C7.7353 7.97105 7.66476 7.80161 7.66445 7.6248C7.66414 7.44798 7.73408 7.27829 7.85888 7.15305C7.98368 7.0278 8.15313 6.95727 8.32994 6.95695Z",
    fill: "#8E97A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25510_48827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.984863 0.303223) rotate(-0.101015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info-2.25d2caaf0f187db86a454993eba64c0b.svg";
export { ForwardRef as ReactComponent };